angular.module('igs.common.credit.card.validation', []);

angular.module('igs.common.credit.card.validation').directive('igsValidCreditCard', [
    'creditCardValidationService',
    function (creditCardValidationService) {
        'use strict';
        return {
            scope: {
                cardType: '=igsValidCreditCard'
            },
            require: 'ngModel',
            link: function ($scope, $elem, $attrs, $ctrl) {
                function validate() {
                    var paymentData = {
                        CardNumber: $ctrl.$viewValue,
                        CardType: $scope.cardType
                    };

                    $ctrl.$setValidity('creditCard', !creditCardValidationService.cardNumberHasError(paymentData));
                }


                $scope.$watch(function () { return $ctrl.$viewValue; }, validate);
                $scope.$watch('cardType', validate);

                validate();
            }
        };
    }
]);

angular.module('igs.common.credit.card.validation').service('creditCardValidationService', [
    function () {
        'use strict';
        var self = this;
        var cardTypes = {
            visa: 'Visa',
            mastercard: 'MasterCard',
            amex: 'American Express',
            discover: 'Discover'
        };

        function cardNumberIsOfType(type, cardNumber) {
            if (!String(cardNumber) || !Number(cardNumber) || !String(type)) {
                return false;
            }

            var strCardNumber = String(cardNumber).trim();

            var regex = getCardTypeRegex(type);
            return regex && regex.test(cardNumber) && luhnFormula(strCardNumber);
        }

        // https://gist.github.com/ShirtlessKirk/2134376
        function luhnFormula(cardNumber) {
            var len = cardNumber.length,
                mul = 0,
                prodArr = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [0, 2, 4, 6, 8, 1, 3, 5, 7, 9]],
                sum = 0;

            while (len--) {
                sum += prodArr[mul][parseInt(cardNumber.charAt(len), 10)];
                //noinspection JSHint
                mul ^= 1;
            }

            return sum % 10 === 0 && sum > 0;
        }

        function inPast(year, month) {
            if (Number(month)) {
                var today = Number('' + moment().year() + (moment().format('MM'))),
                    exDate = Number('' + year + month);
                return exDate < today;

            } else if (Number(year)) {
                return moment().year() > year;

            } else {
                return null;
            }
        }

        function getCardTypeRegex(cardType) {
            switch (cardType) {
                case cardTypes.visa:
                    return /^4(\d{13}|\d{15})$/;
                case cardTypes.mastercard:
                    return /^5\d{15}$/;
                case cardTypes.amex:
                    return /^3\d{14}$/;
                case cardTypes.discover:
                    return /^6\d{15}$/;
            }
        }

        self.securityCodeHasError = function (paymentData) {
            var code = paymentData.SecurityCode;

            return !code ||
                !Number(code) ||
                !String(code).trim().length ||
                (String(code).trim().length !== 3 &&
                String(code).trim().length !== 4) ||
                ((paymentData.CardType === cardTypes.visa ||
                paymentData.CardType === cardTypes.discover ||
                paymentData.CardType === cardTypes.mastercard) &&
                String(code).trim().length !== 3) ||
                (paymentData.CardType === cardTypes.amex &&
                String(code).trim().length !== 4);
        };

        self.expirationYearHasError = function (paymentData) {
            var year = paymentData.ExpirationYear;
            var month = paymentData.ExpirationMonth;

            return !Number(year) ||
                inPast(year, month);
        };

        self.expirationMonthHasError = function (paymentData) {
            var year = paymentData.ExpirationYear;
            var month = paymentData.ExpirationMonth;
            return !Number(month) ||
                inPast(year, month);
        };

        self.cardTypeHasError = function (paymentData) {
            return !paymentData.CardType ||
                !_.includes(_.toArray(cardTypes), paymentData.CardType);
        };

        self.creditCardHasError = function (paymentData) {
            return self.getCreditCardError(paymentData);
        };

        self.cardNumberHasError = function (paymentData) {
            var number = paymentData.CardNumber;
            var type = paymentData.CardType;

            return !number ||
                !cardNumberIsOfType(type, number);
        };

        self.nameHasError = function (paymentData) {
            return !paymentData.Name;
        };
    }
]);
